module.exports = __webpack_public_path__ + "static/media/biponiShop.026ecfa3.png";